import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { Definition } from "../vo/definition";

@Injectable()
export class DefinitionModelService extends BaseModel {
	private _defDocXml: XMLDocument;
	private _txtFields: Definition[] = [];
	constructor(private httpService: HttpService) {
		super();
	}
	public initialize(url: string): void {
		this._txtFields = [];
		this.loadDefDoc(url);
	}

	private loadDefDoc(url: string): void {
		this.httpService.getXmlData(url).then((res: any) => {
			this._defDocXml = res;
			this.parseDefinition();
		});
	}
	private parseDefinition() {
		this.parseTextFields();
	}
	private parseTextFields(): void {
		let txtFields = this._defDocXml.querySelectorAll("text");
		let definition: Definition;
		let iterator: number = 0,
			node;
		while ((node = txtFields[iterator++])) {
			definition = new Definition();
			definition.id = node.getAttribute("id");
			definition.term = node.getAttribute("term");
			definition.value = node.textContent;
			this._txtFields.push(definition);
		}
		//this._notifier.next('data');
	}
	public get title() {
		return this._defDocXml.querySelectorAll("title")[0].textContent;
	}
	public get txtFields(): Definition[] {
		return this._txtFields;
	}
	public get defaultsVal() {
		let node = this._defDocXml.querySelectorAll("defaults")[0];
		return {
			image: node.getAttribute("image").replace(".swf", ".png"),
			termColor: node.getAttribute("termColor"),
			definitionColor: node.getAttribute("definitionColor"),
			contentBackground:
				node.getAttribute("contentBackground") || "rgba(255, 255, 255, 0)",
			contentBorder: node.getAttribute("contentBorder") || "",
			background: node.getAttribute("background") || "#E1D3A4",
		};
	}
	public getDefinitionById(id: string): string {
		const definition: Definition = this._txtFields.find(
			(item) => item.id === id
		);
		if (definition) {
			return definition.value;
		}
		return "";
	}

	public getTermById(id: string): string {
		const definition: Definition = this._txtFields.find(
			(item) => item.id === id
		);
		if (definition) {
			return definition.term;
		}
		return "";
	}

	public get descDocXml(): any {
		return this._defDocXml;
	}
}
